import { Text } from "@mantine/core";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useProject } from "../../../hooks/useProject";
import type { SiteName } from "../../../utils/enums";
import { MenuItem } from "../MenuItem/MenuItem";

declare const SITE_NAME: SiteName;

interface PageTitleProps {
  title: string;
}

function PageTitle({ title }: PageTitleProps) {
  const { projectId } = useParams();
  const { project } = useProject(projectId, {
    refetchInterval: false,
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000 // 1 minute
  });

  useEffect(() => {
    if (project) {
      document.title = `${title} - ${project.name} - ${SITE_NAME}`;
    } else {
      document.title = `${title} - ${SITE_NAME}`;
    }
  }, [project, title]);

  return (
    <MenuItem flex="0 1 auto" miw={0}>
      <Text display="block" fw={500} span title={title} truncate>
        {title}
      </Text>
    </MenuItem>
  );
}

export { PageTitle };
